export interface LabelsStoreType {
  [key: string]: string;
}

export enum LabelsStorePayload {
  DE = 'de',
  EN = 'en',
}

export enum LabelsStoreKind {
  INITIAL = 'INITIAL',
}

export interface LabelsStoreAction {
  type: LabelsStoreKind;
  payload: LabelsStoreType;
}
